import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import logo from './assets/images/mafia-logo.png';
import googlePlay from './assets/images/googleplay.png';
import appStore from './assets/images/appstore.svg';
import tiktokLogo from './assets/images/tiktok.png';
import instaLogo from './assets/images/insta.png';
import PrivacyPolicy from './PrivacyPolicy';

// Video constants
const video1 = "https://mafia-web-videos.s3.amazonaws.com/adammafia.mp4";
const video2 = "https://mafia-web-videos.s3.amazonaws.com/startscreen.mp4";
const video3 = "https://mafia-web-videos.s3.amazonaws.com/settings.mp4";

function HomePage() {
  return (
    <>
      {/* HERO SECTION */}
      <section className="hero-landing" id="home">
        <div className="brand-focus">
          <img src={logo} className="logo-main" alt="Mafia Game Logo" />
          <div className="title-wrap">
            <h1 className="ultra-title">TRUST NO ONE</h1>
            <div className="accent-bar"></div>
          </div>
          <p className="hero-tagline">THE ULTIMATE TEST OF TRUST AND DECEPTION</p>
          <div className="badge-row">
            <a href="#home" className="badge-link" aria-label="App Store"><img src={appStore} className="store-badge" alt="App Store" /></a>
            <a href="#home" className="badge-link" aria-label="Google Play"><img src={googlePlay} className="store-badge" alt="Play Store" /></a>
          </div>
        </div>
      </section>

      {/* ABOUT US */}
      <section className="about-section" id="about">
        <div className="content-container">
          <h2 className="section-title">OUR STORY</h2>
          <div className="accent-bar"></div>
          <div className="article-content">
            <p>MAFIA PASS-N-PLAY WAS BORN FROM A PASSION FOR SOCIAL DYNAMICS. WE BELIEVE THAT THE BEST EXPERIENCES HAPPEN WHEN PEOPLE ARE GATHERED IN THE SAME ROOM, CHALLENGING EACH OTHER'S WIT AND INTUITION.</p>
            <p>OUR MISSION IS TO TRANSFORM THE TRADITIONAL EXPERIENCE INTO A SEAMLESS, DIGITAL-ASSISTED JOURNEY. NO MORE MODERATOR ERRORS—JUST PURE ADRENALINE AND DECEPTION WITH FRIENDS.</p>
          </div>
        </div>
      </section>

      {/* STRATEGY SECTION */}
      <section className="strategy-section" id="strategy">
        <div className="content-container">
          <h2 className="section-title">THE STRATEGY GUIDE</h2>
          <div className="accent-bar"></div>
          <div className="article-content">
            <h3>THE PSYCHOLOGY OF DECEPTION</h3>
            <p>In Mafia, the strongest weapon is not a vote, but the ability to control the narrative. As a Mafia member, your success depends on your ability to mirror civilian behavior. The biggest mistake Mafia members make is staying too quiet. Inactivity is a signal of guilt; you must participate in the hunt for the "Mafia" as if your life depends on it.</p>
            <h3>CIVILIAN SURVIVAL LOGIC</h3>
            <p>As a Civilian, you are at a data disadvantage. Your goal is to force Mafia members into making "Verbal Commitments." Ask direct questions. A Mafia member has to invent a lie, while a Civilian only has to recall the truth. Watch for inconsistencies in their stories across multiple rounds. If someone changes their reason for voting, they are likely hiding a dark secret.</p>
            <h3>READING THE ROOM</h3>
            <p>Every action is data. Watch for hesitation during the voting phase. Look for "Micro-deviations"—if a normally loud friend becomes quiet, or a quiet friend becomes aggressive, the role they are playing is likely influencing their natural baseline behavior.</p>
          </div>
        </div>
      </section>

      {/* HOW TO PLAY & VIDEOS */}
      <section className="how-to-play" id="how-to-play">
        <div className="section-header">
          <h2 className="section-title">THE RULES</h2>
          <div className="accent-bar"></div>
        </div>
        <div className="rules-grid">
          {[
            { title: "THE ROLES", desc: "EACH PLAYER IS SECRETLY ASSIGNED A ROLE: MAFIA OR CIVILIAN." },
            { title: "THE SECRET", desc: "MAFIA KNOWS THEIR ALLIES; CIVILIANS MUST FIND THE TRUTH." },
            { title: "THE DEBATE", desc: "DISCUSS BEHAVIOR AND BODY LANGUAGE TO FIND THE MAFIAS." },
            { title: "THE VOTE", desc: "VOTE TO ELIMINATE SUSPECTS. THEIR TRUE ROLE IS THEN REVEALED." },
            { title: "THE CYCLE", desc: "THE GAME LOOPS: DISCUSSION -> VOTING -> REVEAL." },
            { title: "THE VICTORY", desc: "CIVILIANS WIN IF MAFIA ARE GONE. MAFIA WINS BY OUTNUMBERING THEM." }
          ].map((rule, index) => (
            <div className="rule-card" key={index}>
              <span className="rule-number">0{index + 1}</span>
              <h3>{rule.title}</h3>
              <p>{rule.desc}</p>
            </div>
          ))}
        </div>

        {/* VIDEOS RESTORED HERE */}
        <div className="video-stack">
          <div className="device-container">
            <div className="device-frame">
              <video src={video1} autoPlay loop muted playsInline />
            </div>
            <div className="device-caption">SYSTEMS</div>
          </div>
          <div className="device-container featured">
            <div className="device-frame">
              <video src={video2} autoPlay loop muted playsInline />
            </div>
            <div className="device-caption">HOMEPAGE</div>
          </div>
          <div className="device-container">
            <div className="device-frame">
              <video src={video3} autoPlay loop muted playsInline />
            </div>
            <div className="device-caption">SETTINGS</div>
          </div>
        </div>
      </section>

      {/* SOCIAL SECTION */}
      <section className="social-section" id="social">
        <div className="content-container">
          <h2 className="section-title">JOIN THE FAMILY</h2>
          <div className="accent-bar"></div>
          <div className="social-links-row">
            <a href="https://tiktok.com/@mafiapassnplay" target="_blank" rel="noreferrer" className="social-icon-link">
              <img src={tiktokLogo} alt="TikTok" />
              <span>TIKTOK</span>
            </a>
            <a href="https://instagram.com/mafiapassnplay" target="_blank" rel="noreferrer" className="social-icon-link">
              <img src={instaLogo} alt="Instagram" />
              <span>INSTAGRAM</span>
            </a>
          </div>
          <div className="contact-wrap">
            <h2 className="contact-label">DIRECT INQUIRIES</h2>
            <a href="mailto:mafiapassnplay@gmail.com" className="email-link">MAFIAPASSNPLAY<span className="at-symbol">@</span>GMAIL.COM</a>
          </div>
        </div>
      </section>
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App abyss-theme">
        <nav className="main-nav">
          <div className="nav-links">
            <Link to="/">HOME</Link>
            <a href="/#about">ABOUT</a>
            <a href="/#strategy">STRATEGY</a>
            <a href="/#how-to-play">RULES</a>
            <a href="/#social">SOCIAL</a>
            <Link to="/privacy">PRIVACY</Link>
          </div>
        </nav>

        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
        </Routes>

        <footer className="dark-footer">
          <div className="footer-content">
            <img src={logo} className="footer-mini-logo" alt="Logo" />
            <p className="copyright">CREATED BY ADAM BEJI — 2025</p>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;